"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
const web3_utils_1 = require("@theqrl/web3-utils");
const utils_js_1 = require("../common/utils.js");
const qrl_crypto_js_1 = require("../qrl_crypto.js");
const qrl_wallet_js_1 = require("../qrl_wallet.js");
class Address {
    constructor(buf) {
        if (buf.length !== 20) {
            throw new Error('Invalid address length');
        }
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */
    static zero() {
        return new Address((0, utils_js_1.zeros)(20));
    }
    /**
     * Is address equal to another.
     */
    equals(address) {
        return (0, web3_utils_1.uint8ArrayEquals)(this.buf, address.buf);
    }
    /**
     * Is address zero.
     */
    isZero() {
        return this.equals(Address.zero());
    }
    /**
     * Returns hex encoding of address.
     */
    toString() {
        return (0, web3_utils_1.hexToAddress)((0, web3_utils_1.bytesToHex)(this.buf));
    }
    /**
     * Returns Uint8Array representation of address.
     */
    toArray() {
        return this.buf;
    }
    /**
     * Returns the qrl address of a given public key.
     * Accepts "public keys".
     * @param pubKey The public key
     */
    static publicKeyAndDescriptorToAddress(_pubKey, _descriptor) {
        const pubKey = _pubKey;
        (0, utils_js_1.assertIsUint8Array)(pubKey);
        const descBytes = _descriptor;
        (0, utils_js_1.assertIsUint8Array)(descBytes);
        if (pubKey.length !== qrl_crypto_js_1.CryptoPublicKeyBytes) {
            throw new Error(`Expected pubKey to be of length ${qrl_crypto_js_1.CryptoPublicKeyBytes}`);
        }
        return (0, qrl_wallet_js_1.addressFromPublicKeyAndDescriptor)(pubKey, (0, qrl_wallet_js_1.descriptorFromBytes)(descBytes));
    }
}
exports.Address = Address;
//# sourceMappingURL=address.js.map